import * as React from "react"
import { useTranslation } from "react-i18next"

import { useConfig } from "shared/components/ConfigContext"

const usePageTitle = (hasUnsavedChanges: boolean) => {
  const { t } = useTranslation()
  const { brandedName } = useConfig()

  React.useEffect(() => {
    document.title = [hasUnsavedChanges ? t("general.unsaved_symbol") : "", brandedName ?? t("general.title")].join(" ")
  }, [t, hasUnsavedChanges, brandedName])
}

export default usePageTitle
